import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import { Input } from 'antd';
import style from './PriceInput.module.scss';

const PriceInput: React.FC = () => {
	const { setPrice, price, IDSelectedRestaurant } = useContext<IDishAssignmentContext>(DishAssignmentContext);
	const { t } = useTranslation('listing');

	const numberCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
		const num = e.target.value.replace(/^\.|[^\d.]|\.(?=.*\.)|^0+(?=\d)/g, '');
		const numberWithTwoDecimalPlaces =
			num.split('.')[1] && num.split('.')[1].length > 2 ? num.slice(0, num.indexOf('.') + 3) : num;
		setPrice(numberWithTwoDecimalPlaces);
	};

	return (
		<div className={style.container} data-test="PriceInput">
			<Text translationNameSpace="listing" translationKey="priceLabel" theme="neutralLight" size="xs" />
			<Input
				className={style.input}
				onChange={numberCheck}
				value={price}
				allowClear={true}
				disabled={!IDSelectedRestaurant}
				placeholder={t('inputPlaceholder')}
			/>
		</div>
	);
};

export default PriceInput;
